import { render, staticRenderFns } from "./product.vue?vue&type=template&id=b235aa8a"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=b235aa8a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b235aa8a')) {
      api.createRecord('b235aa8a', component.options)
    } else {
      api.reload('b235aa8a', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=b235aa8a", function () {
      api.rerender('b235aa8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/applications/product.vue"
export default component.exports